import { spansOverlap } from '../geom'
import type { CompiledTrack, Zone } from '../track/types'
import { nearBody } from '../track/xindex'
import { NO_TICK } from '../world'
import type { PlayerState, World } from '../world'

/** Feet line inside the zone: horizontal overlap (strict), feet y within the box (inclusive). */
export function feetInZone(p: PlayerState, z: Zone): boolean {
  return spansOverlap(p.x, p.w, z.x, z.w) && p.y >= z.y && p.y <= z.y + z.h
}

export function feetInAny(track: CompiledTrack, p: PlayerState, kind: Zone['kind']): boolean {
  for (const k of nearBody(track.index.zones, p)) {
    const z = track.zones[k]!
    if (z.kind === kind && feetInZone(p, z)) return true
  }
  return false
}

/**
 * Step 6 (speed strips): overlap (re)starts a boost of at least `speedStripSpeedPct`. It never
 * shortens or weakens a running boost, and a running Boost Jet keeps ignoring mud.
 */
export function applySpeedStrips(world: World, i: number): void {
  const p = world.players[i]!
  if (p.respawnAtTick !== NO_TICK || !feetInAny(world.track, p, 'speedStrip')) return
  const { cfg, tick } = world
  const active = p.boostUntil > tick
  const current = active ? p.boostPct : 0
  p.boostUntil = Math.max(p.boostUntil, tick + cfg.speedStripTicks)
  p.boostPct = Math.max(current, cfg.speedStripSpeedPct)
  p.boostIgnoresMud = active && p.boostIgnoresMud
}
